<template>
    <div :id="page.slug" class="page-content">
        <div class="container">
            <div class="heading">
                <h1>{{ page.title }}</h1>
                <p>{{ page.subtitle }}</p>
            </div>
        </div>

        <div class="featured-image">
            <div
                :style="{ backgroundImage: 'url(' + page.image + ')' }"
                class="banner-img lazyload"
            >
                <div class="banner-credits">
                    <div class="container">
                        <a
                            href="https://unsplash.com/@tbzr?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge"
                            target="_blank"
                            class="unsplash-credits"
                            rel="noreferrer"
                        >
                            <span class="unsplash-logo">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 32 32"
                                >
                                    <title>unsplash-logo</title>
                                    <path
                                        d="M10 9V0h12v9H10zm12 5h10v18H0V14h10v9h12v-9z"
                                    ></path>
                                </svg>
                            </span>
                            <span class="unsplash-text">
                                <p class="text1">Arnaud Mesureur</p>
                                <p class="text2">@tbzr</p>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="container marginT">
            <el-row
                v-for="node of page.nodes"
                :id="node.slug"
                :key="node.id"
                :gutter="50"
            >
                <div v-if="node.columns == 2">
                    <el-col
                        v-for="(item, index) in node.node_structure.items"
                        :key="index"
                        :xs="24"
                        :sm="24"
                        :md="12"
                        class="marginT"
                    >
                        <h2 :style="{ marginTop: '0' }">
                            {{ item.title }}
                        </h2>
                        <div v-html="item.description" />
                    </el-col>
                </div>
                <div v-else>
                    <el-col
                        v-for="(item, index) in node.node_structure.items"
                        :key="index"
                        :xs="24"
                        :sm="24"
                        :md="24"
                    >
                        <h2 :style="{ marginTop: '0' }">
                            {{ item.title }}
                        </h2>
                        <span class="separator"></span>
                        <div v-html="item.description" />
                    </el-col>
                </div>
            </el-row>
        </div>

        <div
            v-for="node in accordions"
            id="more-info"
            :key="node.id"
            class="container marginT"
        >
            <h2 :style="{ textAlign: 'center' }">
                {{ node.node_structure.name }}
            </h2>
            <el-row :gutter="40">
                <el-col
                    v-for="(item, index) in node.node_structure.items"
                    :key="index"
                    :xs="24"
                    :sm="12"
                >
                    <h3>{{ item.title }}</h3>
                    <div class="content" v-html="item.content" />
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    async asyncData({ app, store, error }) {
        await store
            .dispatch('general/getPage', app.context.route.name)
            .catch((e) => {
                error({
                    statusCode: e.response.status,
                    message: 'Page not found'
                })
            })
    },

    head() {
        return {
            title: this.page.title,
            meta: [
                {
                    hid: 'title',
                    name: 'title',
                    content: this.page.meta_title
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: this.page.meta_description
                }
            ]
        }
    },

    computed: {
        ...mapGetters({
            page: 'general/page'
        }),
        accordions() {
            return this.page.nodes.filter(function(el) {
                return el.node_structure.type_section === 'accordion'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.full-width {
    display: inline-block;
    width: 100%;
    background: $linen;
    padding: 3em 0;
}

.pricing-tabs {
    display: none;
}

.packing-tables {
    display: table;
    margin: 2em auto 0 auto;

    .pricing-table {
        margin: 0 auto;
        box-shadow: none;
        -webkit-box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.05);
        box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.05);

        &#packing-time {
            border-radius: 8px;
            margin-top: 2em;
        }
    }

    th {
        border-radius: 8px 8px 0 0;
    }
}

.pricing-table {
    width: 100%;
    max-width: 790px;
    margin: 2em auto 0 auto;
    background: $white;
    border-radius: 8px;
    border-collapse: collapse;
    -webkit-box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.05);

    .table-heading {
        background: $floral-white;
        text-align: left;

        th {
            color: $body-light;
        }
    }

    td,
    th {
        padding: 1.5em 2.5em;
        border: 1px solid $linen;
    }

    td {
        color: $body-light;
        letter-spacing: 1px;
    }

    span {
        font-size: 80%;
        letter-spacing: initial;
    }

    th,
    tr td:first-child {
        font-weight: 600;
        color: $heading;
        letter-spacing: initial;
    }

    tbody {
        tr {
            &:hover {
                background: $floral-white;
            }
        }
    }

    &.mobile {
        display: none;
        table-layout: fixed;
        margin: 0;
        width: 100%;
        border-radius: 0 0 8px 8px !important;

        td,
        th {
            padding: 1em;
        }

        tr {
            td:first-child {
                font-size: 90%;
            }

            td:nth-child(2) {
                text-align: center;
            }
        }
    }
}

.note {
    font-size: 90%;
    color: $body-light;
    max-width: 790px;
    margin: 2em auto 0 auto;

    b {
        font-weight: inherit;
        color: $body;
    }
}

#more-info {
    margin-bottom: 2em;

    .content {
        color: $body-light;
        border-bottom: 1px solid $linen;
        padding-bottom: 1em;
        margin: 0;
    }
}

@media only screen and (max-width: 1199px) {
}

@media only screen and (max-width: 991px) {
    .pricing-tabs {
        display: block;
        max-width: 790px;
        margin: 2em auto 0 auto;
    }

    .packing-tables {
        display: none;
    }

    .packing-tabs {
        .el-tabs {
            margin-top: 1em;
        }
    }

    #packing-time {
        margin-top: 0;
    }

    .pricing-table {
        td,
        th {
            padding: 1.5em 2em;
        }

        &.desktop {
            display: none;
        }

        &.mobile {
            display: table;
        }
    }

    .full-width {
        padding: 2em 0;
    }

    .table-heading {
        max-width: 790px;
        margin: 2em auto 0 auto;

        p {
            margin: 0;
            text-transform: uppercase;
            font-size: 0.8em;
            letter-spacing: 0.5px;
            font-weight: 700;
        }
    }
}

@media only screen and (max-width: 767px) {
    #more-info {
        .el-row {
            margin-left: -15px !important;
            margin-right: -15px !important;

            .el-col {
                padding-left: 15px !important;
                padding-right: 15px !important;
            }
        }
    }
}
</style>
